import React from 'react';
import { Link } from 'gatsby';
import classNames from 'classnames';

const WpMenu = ({ className, menuItems }) => {
  if (!menuItems) {
    return null;
  }

  return (
    <ul className={className}>
      {menuItems.map(({ label, uri, url, id, cssClasses, target, connectedNode }) => (
        <li className={classNames(cssClasses)} key={id}>
          {(() => {
            const internalPage = connectedNode?.node;
            const isInternalPage = internalPage && internalPage.__typename === 'WpPage';

            if (isInternalPage) {
              return <Link to={internalPage?.isFrontPage ? '/' : `${uri}`}>{label}</Link>;
            } else {
              return (
                <a href={url} target={target}>
                  {label}
                </a>
              );
            }
          })()}
        </li>
      ))}
    </ul>
  );
};
export default WpMenu;
